import {RxJsonSchema} from 'rxdb';

export const SkincareCountSchema: RxJsonSchema | any = {
    "version": 1,
    "type": "object",
    "title": "Care Count",
    "properties": {
        "date": {
            "type": "string"
        },
        "cleaningCount": {
            "type": ["number", "null"]
        },
        "protectionCount": {
            "type": ["number", "null"]
        },
        "careCount": {
            "type": ["number", "null"]
        },

    },
    "required": [
        "date",
        "cleaningCount",
        "protectionCount",
        "careCount",
    ],
};
